module.exports = __webpack_public_path__ + "img/background-admin.c3505f14.jpg";